import { render } from "./AppProfile.vue?vue&type=template&id=49dba747"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__